import { render } from "./SubmissionPrintPreview.vue?vue&type=template&id=1ec0807a&scoped=true&ts=true"
import script from "./SubmissionPrintPreview.vue?vue&type=script&lang=ts"
export * from "./SubmissionPrintPreview.vue?vue&type=script&lang=ts"

import "./SubmissionPrintPreview.vue?vue&type=style&index=0&id=1ec0807a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec0807a"]])

export default __exports__